import router from '../../router';
import store from '../../store';
import axios from 'axios';
const moment = require('moment');
var common = {};
/**
 * 替换下面路径，还需要改变 public>static>confingOpen.js 的 ifLogin 值
 */
const reviewUrl = window.location.href.split('#')[0]; //打包时使用
// const reviewUrl = "https://www.qiis.cn:8093/app/9186b3d8119840cda5042ff23d89497b/app-api";
const alias = 'emers'; //项目专属Session标识

const report = 'https://www.sdape.cn/pdf'; //打包时使用
/**
 * 使用方法：
 * 1、定义公用方法 添加到 common 中
 * 2、在需要得组件页面中 this.common.(方法名字)
 */

// 判断身份
common.isLogin = function () {
  let currentUser = store.state.currentUser;
  if (currentUser.isAdmin === 1) {
    // 管理员
    return -1;
  }
  if (currentUser.isExpert === 1) {
    // 专家
    return -2;
  }
  // 用户
  return currentUser.tier;
};
common.reportsNumber = function (type) {
  // 类型（1.自评 2.专家）
  axios.post(`${process.env.BASE_URL}api/selfAssessment/reportsNumber`, { type }).then((res) => {
    if (res.data.code == 200) {
    }
  });
};

// 导出报表-get版
common.exportOut = function (exportUrl, searchList, xlsName) {
  // 获取时间，这一步是在下载时文件名带下载日期，例如：用户信息2020-04-27.xls,如无需要可以去掉
  let d = new Date();
  let month = d.getMonth() + 1;
  let day = d.getDate();
  let time = d.getFullYear() + '-' + (String(month).length > 1 ? month : '0' + month) + '-' + (String(day).length > 1 ? day : '0' + day);
  // 地址
  // 参数
  let params = '?';
  for (let key in searchList) {
    params = params + key + '=' + searchList[key] + '&';
  }
  params = params.substring(0, params.length - 1);

  function createObjectURL(object) {
    return window.URL ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
  }
  var xhr = new XMLHttpRequest();
  var formData = new FormData();
  xhr.open('get', exportUrl + params); // url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
  xhr.setRequestHeader('token', sessionStorage.getItem(`${alias}userToken`));
  xhr.responseType = 'blob';
  xhr.onload = function (e) {
    if (this.status === 200) {
      var blob = this.response;
      // xls文件名称
      var filename = `${xlsName}${time}.xls`;
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var a = document.createElement('a');
        var url = createObjectURL(blob);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    }
  };
  xhr.send(formData);
};
// 导出报表 axios-post版
common.exportOutPost = function (exportUrl, searchList, xlsName) {
  return new Promise((resolve, reject) => {
    axios
      .post(exportUrl, searchList, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded', //请求的数据类型为form data格式
        },
        responseType: 'blob',
      })
      .then(
        (response) => {
          const BLOB = response.data; // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
          const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
          fileReader.readAsDataURL(BLOB);
          // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
          fileReader.onload = (event) => {
            // 处理load事件。该事件在读取操作完成时触发
            // 新建个下载的a标签，完成后移除。
            let a = document.createElement('a');
            a.download = `${xlsName}`;
            a.href = event.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
          resolve();
        },
        (response) => { }
      )
      .catch((error) => {
        reject(error);
      });
  });
};
// 清除 cookie 的方法
common.delCookie = function () {
  // var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  // if (keys) {
  //     for (var i = keys.length; i--;)
  //         document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
  // }
  let cookies = window.document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    let eqPos = cookie.indexOf('=');
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
  if (cookies.length > 0) {
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf('=');
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      let domain = location.host.substr(location.host.indexOf('.'));
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + domain;
    }
  }
};
// 修改钱数加逗号
common.formatNumber = function (value) {
  // 检查输入是否为数字
  if (typeof value != 'number') {
    return '--';
  }
  // 将输入数字保留两位小数
  const formattedValue = parseFloat(value).toFixed(2);
  // 使用正则表达式添加逗号分隔符
  const numberWithCommas = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return numberWithCommas;
};

//获取字符串中某个字符的个数
common.sGetCharCount = function (SubChar, StrTemp) {
  let count, i;
  count = 0;
  for (i = 0; i < StrTemp.length; i++) {
    if (StrTemp.substr(i, 1) == SubChar) {
      count = count + 1;
    }
  }
  return count;
};
common.downloadFile = function (url) {
  //下载文件方法
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none'; // 防止影响页面
  iframe.style.height = 0; // 防止影响页面
  iframe.src = url;
  document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
  // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
  setTimeout(() => {
    iframe.remove();
  }, 5 * 60 * 1000);
};
// 豪秒转几天几小时几分钟
common.formatDuration = function (milliseconds) {
  const duration = moment.duration(milliseconds);
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  if (days > 0) {
    return `${days} 天 ${hours} 小时 ${minutes} 分钟`;
  } else if (hours > 0) {
    return `${hours} 小时 ${minutes} 分钟`;
  } else {
    return `${minutes} 分钟`;
  }
};
//获取cookie对象
common.getCookieParam = function (paramArr) {
  let cookieParam = {};
  if (paramArr.length > 0) {
    paramArr.forEach((element) => {
      cookieParam[element.split('=')[0]] = element.split('=')[1];
    });
  }
  return cookieParam;
};
// vueTagsInput 标签 点击方法
common.addlabels = function (tags, item) {
  if (tags.length <= 4) {
    let res = tags.findIndex((v) => {
      return v.id == item.id;
    });
    if (res == -1) {
      tags.push({ text: item.name, id: item.id });
    } else {
    }
  } else {
  }
};
// 返回上一页，没有返回主页
common.returnBtn = function () {
  if (window.history.length <= 1) {
    router.push({ path: store.getters.getHomePage });
    return false;
  } else {
    router.go(-1);
  }
};
// 判断 json 对象是否为空
common.isEmptyObject = function (obj) {
  for (var key in obj) {
    return false;
  }
  return true;
};
// 处理 传参 空值 转为 undefined
common.processing = function (params) {
  for (const key in params) {
    if (params[key] || params[key] !== '' || params[key].length) {
    } else {
      params[key] = undefined;
    }
  }
};
// 转换文件大小
common.convertSize = function (fileSize) {
  let result = '';
  if (fileSize >= 1073741824) {
    // B => GB
    result = fileSize % 1073741824 === 0 ? fileSize / 1073741824 + 'G' : Math.trunc(fileSize / 1073741824) + 'G';
  } else if (fileSize >= 1048576) {
    // B => MB
    result = fileSize % 1048576 === 0 ? fileSize / 1048576 + 'MB' : Math.trunc(fileSize / 1048576) + 'MB';
  } else if (fileSize >= 1024) {
    // B => KB
    result = fileSize % 1024 === 0 ? fileSize / 1024 + 'KB' : Math.trunc(fileSize / 1024) + 'KB';
  } else {
    result = fileSize + 'B';
  }
  return result;
};
//获取URL参数
common.getQueryString = function (name) {
  let search = window.location.search.substr(1) || window.location.hash.split('?')[1];
  if (search) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    let r = search.match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
  }
  return null;
};
// 数组对象去重
common.cutarray = function (arr) {
  let obj = {};
  let brr = [];
  arr.forEach((item) => {
    if (obj[item.id] == undefined) {
      obj[item.id] = 1;
      brr.push(item);
    } else {
      obj[item.id] += 1;
    }
  });
  return brr;
};
//更新token
common.getNewToken = function () {
  var config_token;
  if (window.location.href.split('/app')[1]) {
    let tags = window.location.href.split('/app')[1];
    config_token = tags.split('/')[1];
  }
  if (config_token == '') {
    config_token = 'null';
  }
  axios.post(`${process.env.BASE_URL}api/app/updateToken`).then((res) => {
    if (res.data.code == 200) {
      sessionStorage.setItem(`${this.alias}token`, res.data.token);
    }
  });
};
//输入校验
/**
 * @val *必填,所需校验属性值
 * @key *必填,所需校验属性的key值,没有需传null,若为null则返回val,若不为null则返回对象obj
 * @obj *必填,所需校验属性所在的对象,没有需传null,若为null则返回val,若不为null则返回对象obj
 * @formatType *必填,验证类型："Int-正整数"；"float-小数"
 * @floatLength 若需要验证为小数(formatType=float)，需验证的小数位数（1或2)
 * @ifSpecial  基于小数验证，是否需要特殊验证（允许输入小数但小数仅允许为.5）
 */
common.formatNumInput = function (val, key, obj, formatType, floatLength, ifSpecial) {
  let temp = val.toString();
  if (formatType == 'float') {
    //小数验证
    temp = temp.replace(/。/g, '.');
    temp = temp.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
    temp = temp.replace(/^\./g, ''); //验证第一个字符是数字
    temp = temp.replace(/\.{2,}/g, ''); //只保留第一个, 清除多余的
    temp = temp.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
    if (floatLength == 2) {
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
    } else {
      temp = temp.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'); //只能输入1个小数
    }
    if (ifSpecial) {
      if (temp.indexOf('.') > 0 && temp.indexOf('.') != temp.length - 1) {
        temp = Math.floor(Number(temp)) + '.5';
      }
      if (temp.indexOf('.') < 0) {
        temp = Number(temp);
      }
    }
  } else {
    //正整数验证
    temp = temp.replace(/[^\.\d]/g, '');
    temp = temp.replace('.', '');
    temp = temp == '' ? '' : Number(temp);
  }
  if (obj) {
    obj[key] = temp;
    // this.$set(obj, key, temp)
    return obj;
  } else {
    val = temp;
    return val;
  }
};
//el-table表格删除数据后，el-pagination自动向前翻页
// 1.删除最后一页全部数据时，删除成功后，分页组件需要自动往前翻页。
// 2.一次删除多页数据时，如删除之前，当前页在最后一页，删除成功之后，分页组件需要自动往前翻页。
// 3.只有1页时，自动隐藏分页组件。
const AutoPageForward = function (Pagination) {
  return {
    props: {
      ...Pagination.props,
    },
    watch: {
      total(newTotal) {
        if (this.currentPage > 1 && this.currentPage * this.pageSize - newTotal >= this.pageSize) {
          const newCurrentPage = Math.ceil(newTotal / this.pageSize) || 1;
          this.$listeners['current-change'](newCurrentPage);
        }
      },
    },
    render(h) {
      if (this.$props.total > this.$props.pageSize || this.$props.currentPage > 1) {
        return h(Pagination, {
          on: { ...this.$listeners },
          props: this.$props,
          attrs: this.$attrs,
          slots: this.$slots,
          scopedSlots: this.$scopedSlots,
        });
      }
    },
  };
};
class DynamicBoxLayout {
  constructor(containerSelector, boxSelector, boxWidth, boxMargin) {
    this.container = containerSelector; // 直接使用传入的元素
    this.boxes = this.container.querySelectorAll(boxSelector);
    if (!(this.boxes && this.boxes.length)) return;
    const computedStyle = getComputedStyle(this.boxes[0]);
    const marginLeft = parseFloat(computedStyle.marginLeft);
    const marginRight = parseFloat(computedStyle.marginRight);
    const borderLeftWidth = parseFloat(computedStyle.borderLeftWidth);
    const borderRightWidth = parseFloat(computedStyle.borderRightWidth);
    this.outside = marginLeft + marginRight + borderLeftWidth + borderRightWidth;
    this.boxWidth = boxWidth;
    this.boxMargin = boxMargin;
    this.updateBoxLayout = this.updateBoxLayout.bind(this);
    this.updateBoxLayout();
    let timeout;
    window.addEventListener('resize', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.updateBoxLayout();
      }, 100); // 调整延迟时间以优化性能和响应性
    });
  }
  calculateBoxCount() {
    const containerWidth = this.container.offsetWidth;
    const boxCount = Math.floor(containerWidth / this.boxWidth);
    return boxCount;
  }
  updateBoxLayout() {
    const boxCount = this.calculateBoxCount();
    this.boxes.forEach((box) => {
      box.style.width = `calc(${100 / boxCount}% - ${this.outside}px )`;
    });
  }
}
export { reviewUrl, AutoPageForward, common, alias, DynamicBoxLayout, report };
